import { useFetchMutation } from "common/queries/hooks";
import { GenerateOrderPdf } from "common/types/pdfs";

import { urls } from "./constants";

export const useGenerateOrderPdfMutation = (openPrintModal = true) => {
  return useFetchMutation<GenerateOrderPdf, Blob>({
    fetch: (body) => ({
      url: urls.generateOrderPdf(),
      method: "POST",
      body,
      responseContentType: "application/pdf",
    }),
    config: {
      onSuccess: (resp) => {
        const url = window.URL.createObjectURL(resp);
        const opened = window.open(url);
        if (opened) {
          opened.focus();
          if (openPrintModal) {
            opened.print();
          }
        }
      },
      onError: () => {
        // TODO sc-27587: Port over toasts and consume here to give feedback when this fails
      },
    },
  });
};
